import 'rc-tabs/assets/index.css';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import styled, { injectGlobal } from 'react-emotion';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';

import { ALL_CATEGORIES } from '../../../constants/events';
import AMPLITUDE_EVENT_NAMES from '../../../amplitude/constants';
import categories from '../../../constants/categories';
import { logAmplitudeEvent } from '../../../redux/actions/amplitude';
import { setActiveCategory } from '../../../redux/actions/categories';
import Style from '../../../styles/common';

const categoryList = [ALL_CATEGORIES, ...categories];

injectGlobal`
  .rc-tabs {
    background-color: white;
  }
  
  .rc-tabs-nav {
    height: ${Style.MEASUREMENT.CATEGORY_NAV.HEIGHT}px;
  }
  
  .rc-tabs-tab {
    padding: 15px 20px;
  }
  
  .rc-tabs-tab-prev,
  .rc-tabs-tab-next {
    line-height: ${Style.MEASUREMENT.CATEGORY_NAV.HEIGHT}px;
  }
  
  .rc-tabs-tab-arrow-show svg {
    vertical-align: -0.35em;
  }
  
  .rc-tabs-tab-btn-disabled svg {
    opacity: 0.5;
  }
  
  .rc-tabs-tab-active,
  .rc-tabs-tab-active:hover {
    color: ${Style.color.activeText};
  }
  
  .rc-tabs-ink-bar {
    background-color: ${Style.color.activeText};
  }
  
  .rc-tabs-tab:hover {
    color: ${Style.color.activeText};
  }
`;

const Container = styled('div')`
  position: fixed;
  top: ${Style.MEASUREMENT.MASTHEAD.HEIGHT}px;
  width: 100%; // Necessary to show navigation arrows
  z-index: 20;
`;

const Icon = styled(FontAwesomeIcon)`
  cursor: pointer;
  color: ${Style.color.defaultText};
  width: 20px;
  height: 20px;
`;

class CategoryNav extends Component {
  static propTypes = {
    activeCategory: PropTypes.object.isRequired,
  };

  render() {
    return (
      <Container>
        <Tabs
          activeKey={this.props.activeCategory.value}
          renderTabBar={() => <ScrollableInkTabBar
            onTabClick={this.onSelect}
            nextIcon={<Icon icon="chevron-right" />}
            prevIcon={<Icon icon="chevron-left" />}
          />}
          renderTabContent={() => <TabContent />}
        >
          {CategoryNav.getMenuItems()}
        </Tabs>
      </Container>
    );
  }

  static getMenuItems() {
    return categoryList.map(category => {
      return (
        <TabPane tab={category.label} key={category.value}>
          <span />
        </TabPane>
      );
    });
  };

  onSelect = key => {
    const category = categoryList.find(category => category.value === key);
    this.props.setActiveCategory(category);
    this.props.logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.CATEGORY_SET, { category: category.label });
  }
}

export default connect(
  state => ({ activeCategory: state.activeCategory }),
  { logAmplitudeEvent, setActiveCategory }
)(CategoryNav);



// WEBPACK FOOTER //
// ./src/views/Browse/CategoryNav/CategoryNav.js